import './style/index.less';
import ImportFailDetail from './ImportFailDetail';

export default ImportFailDetail;
